<template>
  <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
    <Loading v-if="loading"/>
    <template v-else>
      <div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
           id="kt_content">
        <!-- begin:: Content -->
        <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
          <!--begin::Portlet-->
          <div class="kt-portlet">

            <div v-if="criticalErrorsList && criticalErrorsList.length > 0"
                 class="kt-portlet__body app_service__form-body">
              <div v-for="error in criticalErrorsList"
                   class="alert alert-warning fade show"
                   role="alert">
                <div class="alert-icon"><i class="flaticon-warning"></i></div>
                <div class="alert-text">{{ error }}</div>
              </div>
            </div>

            <div v-else class="kt-portlet__body">
              <div class="kt-section__content">
                <div class="form-group col-md-6">
                  <input id="filter-text-box"
                         type="text"
                         v-on:input.prevent="quickFilter"
                         :placeholder="$t('Поиск')"
                         class="form-control">
                </div>


                <!--begin::Accordion-->
                <div v-if="window.width < 950"
                     class="accordion accordion-light  accordion-toggle-arrow" id="service-calls">
                  <div class="card" v-for="serviceCall in serviceCallsList">
                    <div class="card-header" :id="'sc' + serviceCall.number">
                      <div v-show="serviceCall.visible" class="card-title collapsed"
                           data-toggle="collapse"
                           :data-target="'#scc' + serviceCall.number" aria-expanded="false"
                           :aria-controls="'scc' + serviceCall.number">
                        {{ serviceCall.number }}
                        {{ serviceCall.theme }}
                      </div>
                    </div>
                    <div v-show="serviceCall.visible" :id="'scc' + serviceCall.number"
                         class="collapse"
                         :aria-labelledby="'sc' + serviceCall.number" data-parent="#service-calls"
                         style="">
                      <div class="card-body">

                        <div>
                          {{$t('Номер')}}:
                          {{serviceCall.number}}
                        </div>
                        <div>
                          {{$t('Дата создания')}}:
                          {{serviceCall.created_at | formatDateTime}}
                        </div>
                        <div>
                          {{$t('Тема')}}:
                          {{serviceCall.theme}}
                        </div>
                        <div>
                          {{$t('Статус')}}:
                          {{serviceCall.state}}
                        </div>
                        <div>
                          {{$t('Тип заявки')}}:
                          {{serviceCall.theme}}
                        </div>
                        <div>
                          {{$t('Категория')}}:
                          {{serviceCall.category}}
                        </div>
                        <div>
                          {{$t('Услуга')}}:
                          {{serviceCall.service}}
                        </div>
                        <div>
                          {{$t('Ответственный')}}:
                          {{serviceCall.responsible}}
                        </div>
                        <div>
                          {{$t('Регламентное время решения')}}:
                          {{serviceCall.deadline.deadLineTime | formatDateTime}}
                        </div>

                        <router-link :to="{name: 'service.card', params: {id: serviceCall.id}}"
                                     class="btn btn-success">Подробнее
                        </router-link>

                      </div>
                    </div>
                  </div>
                </div>
                <!--end::Accordion-->

                <ag-grid-vue
                  v-else
                  style="width: 100%;"
                  @gridReady="onGridReady"
                  @rowClicked="gotoRequestCard"
                  :localeText="localeText"
                  class="ag-theme-material"
                  :gridOptions="gridOptions"
                  :columnDefs="columnsList"
                  domLayout='autoHeight'
                  rowSelection="multiple"
                  rowMultiSelectWithClick="true"
                  :rowData="serviceCallsList">
                </ag-grid-vue>
              </div>
            </div>

            <!--end::Form-->
          </div>
          <!--end::Portlet-->
        </div>

        <!-- end:: Content -->
      </div>
    </template>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import Api from '../Api';
import Loading from '../components/Loading';
import i18n from '../i18n';
import router from '../router';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

export default {
  name: 'ServiceCallList',
  data() {
    return {
      loading: true,
      window: {
        width: 1024,
        height: 900,
      },
      messagesList: [],
      criticalErrorsList: [],
      error: '',
      gridOptions: {
        pagination: true,
        getRowNodeId(data) {
          return data.id;
        },
        paginationPageSize: 20,
        singleClickEdit: true,
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
        },
      },
      localeText: {
        page: i18n.t('message.grid.page'),
        of: i18n.t('message.grid.of'),
        to: i18n.t('message.grid.to'),
        loadingOoo: i18n.t('message.grid.loadingOoo'),
        noRowsToShow: i18n.t('message.grid.noRowsToShow'),
        filterOoo: i18n.t('message.grid.filterOoo'),
        applyFilter: i18n.t('message.grid.applyFilter'),
        equals: i18n.t('message.grid.equals'),
        notEqual: i18n.t('message.grid.notEquals'),
        lessThan: i18n.t('message.grid.lessThan'),
        greaterThan: i18n.t('message.grid.greaterThan'),
        lessThanOrEqual: i18n.t('message.grid.lessThanOrEqual'),
        greaterThanOrEqual: i18n.t('message.grid.greaterThanOrEqual'),
        inRange: i18n.t('message.grid.inRange'),
        contains: i18n.t('message.grid.contains'),
        notContains: i18n.t('message.grid.notContains'),
        startsWith: i18n.t('message.grid.startsWith'),
        endsWith: i18n.t('message.grid.endsWith'),
        andCondition: i18n.t('message.grid.andCondition'),
        orCondition: i18n.t('message.grid.orCondition'),
      },
      columnsList: [],
      serviceCallsList: [],
    };
  },
  created() {
    this.fetchData();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  watch: {
    $route: 'fetchData',
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    gotoRequestCard(row) {
      router.push({ name: 'service.card', params: { id: row.data.UUID } });
    },
    fetchData() {
      this.loading = true;
      const request = Api.getUserServiceCalls();
      request.then((response) => {
        if (response.data.errors && response.data.errors.length > 0) {
          response.data.errors.forEach((el) => {
            this.criticalErrorsList.push(el);
          });
        } else {
          response.data.serviceCallsList.forEach((el) => {
            let searchString = '';
            Object.keys(el).forEach((key) => {
              if (typeof el[key] !== 'object') {
                searchString = `${searchString} ${el[key]}`;
              }
            });
            el.searchString = searchString;
            el.visible = true;

            this.serviceCallsList.push(el);
          });
          this.serviceCallsList = response.data.serviceCallsList;
        }
      });
      request.catch((error) => {
        if (error.response.data) {
          this.error = error.response.data.error;
        } else {
          this.criticalErrorsList.push(i18n.t('Ошибка идентификации пользователя'));
        }
      });
      request.finally(() => {
        this.loading = false;
      });
    },
    quickFilter($event) {
      if (this.window.width < 950) {
        this.serviceCallsList.forEach((el) => {
          el.visible = el.searchString.includes($event.target.value);
        });
      } else {
        this.gridApi.setQuickFilter($event.target.value);
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
  },
  components: {
    Loading,
    AgGridVue,
  },
  beforeMount() {
    this.columnsList = [
      {
        headerName: i18n.t('Номер'),
        field: 'number',
        filter: true,
      },
      {
        headerName: i18n.t('Дата создания'),
        field: 'created_at',
        filter: true,
        valueGetter: params => this.$options.filters.formatDateTime(
          params.data.created_at,
        ),
      },
      {
        headerName: i18n.t('Тема'),
        field: 'theme',
        filter: true,
      },
      {
        headerName: i18n.t('Статус'),
        field: 'state',
        filter: true,
      },
      {
        headerName: i18n.t('Тип заявки'),
        field: 'type',
        filter: true,
      },
      {
        headerName: i18n.t('Категория'),
        field: 'category',
        filter: true,
      },
      {
        headerName: i18n.t('Услуга'),
        field: 'service',
        filter: true,
      },
      {
        headerName: i18n.t('Ответственный'),
        field: 'responsible',
        filter: true,
      },
      {
        headerName: i18n.t('Регламентное время решения'),
        field: 'deadline',
        filter: true,
        valueGetter: params => this.$options.filters.formatDateTime(
          params.data.deadline.deadLineTime,
        ),
      },
    ];
  },
};
</script>

<style lang="scss">
  .app__portlet-head, .kt-portlet__body {
    font-family: "Roboto", serif;
  }


  .app_service__form-body {
    font-family: "Roboto", serif;

    fieldset {
      max-width: 900px;
      margin: 0 auto;
    }
  }
</style>
